<template lang="html">
  <div class="documentation-table">
    <h6>{{ title }}</h6>
    <p class="documentation-table-description" v-if="description">{{ description || "&nbsp;" }}</p>
    <div class="table card">
      <TableComponent
        :data="data"
        :show-filter="false"
        :show-caption="false"
        :cache-lifetime="0"
        sort-by="id"
        sort-order="asc"
        >

        <TableColumn v-for="(column, index) in columns" 
          v-if="column.key !== 'Details'"
          :key="column.id" 
          :show="column.key" 
          :label="column.label" 
          :sortable="false">
        </TableColumn>

        <TableColumn
          v-if="this.title === 'Input Params'"
          show="Details" 
          label="Details" 
          :sortable="false">
          <template slot-scope="row">
            <p v-if="row.Details !== 'Claim your API key here'">{{ row.Details }}</p>
            <p v-else>Claim your API key <router-link :to="'/pricing'">{{ row.Details.substring(19) }}</router-link></p>
          </template>
        </TableColumn>
      </TableComponent>
    </div>
  </div>
</template>

<script>
import { TableComponent, TableColumn } from "vue-table-component";

export default {
  components: {
    TableComponent,
    TableColumn
  },
  props: ["title", "data", "columns", "description"]
};
</script>
<style scoped lang="css">
.table.card {
  margin-bottom: 0;
  overflow-x: auto;
  white-space: nowrap;
}

.card {
  padding: 0 15px;
  color: black;
  margin-bottom: 25px;
  /* box-shadow: 0 7px 15px 0 rgba(0, 0, 0, 0.22), 0 2px 7px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 11px 0 rgba(198, 192, 192, 0.5);
  width: 100%;
}

.documentation-table {
  margin-bottom: 2.5rem;
}

.documentation-table-description {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

@media only screen and (min-width: 992px) {
  .table.card {
    overflow-x: initial;
    white-space: unset;
    font-size: 0.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/documentation-table.vue